'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AiCheckActive1 = function (_React$Component) {
    _inherits(AiCheckActive1, _React$Component);

    function AiCheckActive1() {
        _classCallCheck(this, AiCheckActive1);

        return _possibleConstructorReturn(this, (AiCheckActive1.__proto__ || Object.getPrototypeOf(AiCheckActive1)).apply(this, arguments));
    }

    _createClass(AiCheckActive1, [{
        key: 'svgPath',
        value: function svgPath(strokeColor, strokeWidth) {
            return _react2.default.createElement(
                'g',
                null,
                _react2.default.createElement(
                    'g',
                    null,
                    _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, fill: '#FFFFFF', d: 'M43.5,9h-23C14.149,9,9,14.149,9,20.5v23C9,49.851,14.149,55,20.5,55h23C49.851,55,55,49.851,55,43.5v-23 C55,14.149,49.851,9,43.5,9L43.5,9z' }),
                    _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, fill: '#D0CFCE', d: 'M44,10c5.514,0,10,4.486,10,10v24c0,5.514-4.486,10-10,10H20c-5.514,0-10-4.486-10-10V20 c0-5.514,4.486-10,10-10H44 M44,8H20C13.373,8,8,13.373,8,20v24c0,6.627,5.373,12,12,12h24c6.627,0,12-5.373,12-12V20 C56,13.373,50.627,8,44,8L44,8z' }),
                    _react2.default.createElement('path', { stroke: strokeColor, strokeWidth: strokeWidth, fill: '#616463', d: 'M28.433,35.656l-3.08-3.08c-0.59-0.59-1.547-0.59-2.137,0l-0.848,0.848c-0.59,0.59-0.59,1.547,0,2.137 l4.996,4.996c0.59,0.59,1.547,0.59,2.137,0l12.13-12.13c0.59-0.59,0.59-1.547,0-2.137l-0.848-0.848c-0.59-0.59-1.547-0.59-2.137,0 L28.433,35.656z' })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var strokeColor = this.props.strokeColor || 'white';
            var strokeWidth = this.props.strokeWidth || 0;
            var viewBox = '0 0 64 64';
            var style = {
                fontSize: '200%',
                verticalAlign: '-23%'
            };

            if (this.props.noPad) {
                viewBox = '8 8 48 48';
                style = {};
            }

            var props = _underscore2.default.omit(this.props, 'noPad', 'strokeColor');

            if (this.props.strokeWidth > 0) {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-check-active-1', viewBox: viewBox, style: style }, props),
                    this.svgPath(strokeColor, strokeWidth),
                    this.svgPath('white', 0)
                );
            } else {
                return _react2.default.createElement(
                    _reactIconBase2.default,
                    _extends({ className: 'ai ai-check-active-1', viewBox: viewBox, style: style }, props),
                    this.svgPath('white', 0)
                );
            }
        }
    }], [{
        key: 'propTypes',
        get: function get() {
            return Object.assign({}, _reactIconBase2.default.propTypes, {
                strokeColor: _propTypes2.default.string,
                strokeWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
                noPad: _propTypes2.default.bool
            });
        }
    }]);

    return AiCheckActive1;
}(_react2.default.Component);

exports.default = AiCheckActive1;